import { FileObject, FileWithPath } from "../typings/FileObject.type";

export const convertToFileObject = (file: FileWithPath): Promise<FileObject> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      resolve({
        file: Object.assign(file, { preview: URL.createObjectURL(file) }),
        data: reader.result as string
      });
    };

    reader.onerror = reject;

    reader.readAsDataURL(file); // Converts file to Base64
  });
};
